import { CurrencyEnum } from '@systemeio/ui'
import { PricePlanType } from '@systemeio/types'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useSWR from 'swr'

export function useUserPricePlans(currency?: CurrencyEnum) {
  const { fetcher } = useFetch<RequestMethodsEnum.get, PricePlanType[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: userPricePlans, mutate: mutateUserPricePlans } = useSWR(() => {
    if (currency) {
      return `/api/dashboard/customer/price-plans/${currency}`
    }
    return null
  }, fetcher)

  return { userPricePlans, mutateUserPricePlans }
}
